import * as React from "react";
import TransactionPeriodList from "./TransactionGrid";
import CurrentTransactions from "./CurrentTransactions";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  getCurrentTransactionperiods,
  getTransactionperiods,
} from "../../actions/transactionperiod.action.js";

const TransactionPeriod = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCurrentTransactionperiods());
    dispatch(getTransactionperiods());
  }, []);
  return (
    <div className="page pt-0">
      <div className="pt-4">
        <CurrentTransactions />
      </div>
      <div className="container">
        <TransactionPeriodList />
      </div>
    </div>
  );
};

export default TransactionPeriod;
